import React from 'react';
import {
  object, number,
} from 'yup';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';

// const attr = [
//   'skin', 'hair', 'hat', 'arm', 'glasses', 'forearm', 'cloth',
//   'beard', 'necklace',
// ];

const attr = [
  'body', 'bodylight', 'tail', 'face', 'nose', 'eyes', 'facemask', 'necklace',
  'hair', 'back_l', 'back_r', 'front_l', 'front_r', 'egg',
];

const defaults = {
  src: '',
  probi: 0,
  type: '',
  bloodline: '',
  description: '',
};

const FormPic = ({
  pic,
}) => (
  <FormResource
    {...{
      defaults,
      schema: object({
        probi: number().max(1).min(0).required(),
      }),
      stored: pic ? {
        ...pic,
        bloodline: pic.bloodline.join(', '),
      } : undefined,
      api: '/api/site/pics',
      onSubmit: (v) => ({
        ...v,
        bloodline: v.bloodline.split(',').map((x) => x.trim()),
      }),
    }}
  >
    <FormGroup name="probi" label="Probability(0 - 1)"/>
    <FormGroup name="type" as="select">
      {attr.map((a) => (
        <option key={a} value={a}>{a}</option>
      ))}
    </FormGroup>
    <FormGroup name="bloodline" />
    <FormGroup name="description" />

    <FormGroup
        name="src"
        label="Image"
        as="coverImg"
        api="/api/site/pics/files"
    />

  </FormResource>
);

export default FormPic;
